import apiClient, { extractData } from "./client";

export async function getAdvances(params = {}) {
  const response = await apiClient.get("/advances", { params });
  return extractData(response);
}

export async function getAdvance(id) {
  const response = await apiClient.get(`/advances/${id}`);
  return extractData(response);
}

export async function getAdvanceHistory(id) {
  const response = await apiClient.get(`/advances/${id}/history`);
  return extractData(response);
}

export async function createAdvance(data) {
  const response = await apiClient.post("/advances", data);
  return extractData(response);
}

export async function approveAdvance(id, data = {}) {
  const response = await apiClient.post(`/advances/${id}/approve`, data);
  return extractData(response);
}

export async function amendAdvance(id, data = {}) {
  const response = await apiClient.patch(`/advances/${id}`, data);
  return extractData(response);
}

export async function rejectAdvance(id, data = {}) {
  const response = await apiClient.post(`/advances/${id}/reject`, data);
  return extractData(response);
}

export async function cancelAdvance(id) {
  const response = await apiClient.post(`/advances/${id}/cancel`);
  return extractData(response);
}

export async function cancelApprovedAdvance(id, data = {}) {
  const response = await apiClient.post(`/advances/${id}/cancel-approved`, data);
  return extractData(response);
}

export async function updateAdvanceInstallmentSchedule(id, data) {
  const response = await apiClient.post(
    `/advances/${id}/installment-schedule`,
    data,
  );
  return extractData(response);
}

export async function postponeAdvanceInstallment(id, data) {
  const response = await apiClient.post(
    `/advances/${id}/postpone-installment`,
    data,
  );
  return extractData(response);
}

export async function postponeAdvanceDisbursement(id, data) {
  const response = await apiClient.post(
    `/advances/${id}/postpone-disbursement`,
    data,
  );
  return extractData(response);
}

export async function getPendingDisbursementAdvances() {
  const response = await apiClient.get("/advances/pending-disbursement");
  return extractData(response);
}

export async function getHrAdvanceApprovalContext() {
  const response = await apiClient.get("/advances/hr-approval-context");
  return extractData(response);
}

export async function referAdvanceToGm(id, data = {}) {
  const response = await apiClient.post(`/advances/${id}/refer-to-gm`, data);
  return extractData(response);
}

export async function getDisbursementTargets(id) {
  const response = await apiClient.get(`/advances/${id}/disbursement-targets`);
  return extractData(response);
}

export async function assignAdvanceDisbursement(id, data) {
  const response = await apiClient.post(
    `/advances/${id}/assign-disbursement`,
    data,
  );
  return extractData(response);
}

export async function getAssignedDisbursementAdvances() {
  const response = await apiClient.get("/advances/assigned-disbursement");
  return extractData(response);
}

export async function confirmAdvanceDisbursement(id) {
  const response = await apiClient.post(`/advances/${id}/confirm-disbursement`);
  return extractData(response);
}

export async function reportAdvanceNotDisbursed(id, data = {}) {
  const response = await apiClient.post(
    `/advances/${id}/report-not-disbursed`,
    data,
  );
  return extractData(response);
}

export async function returnAdvanceToHr(id, data = {}) {
  const response = await apiClient.post(`/advances/${id}/return-to-hr`, data);
  return extractData(response);
}

export async function returnAdvanceDisbursement(id, data = {}) {
  const response = await apiClient.post(
    `/advances/${id}/return-disbursement`,
    data,
  );
  return extractData(response);
}

export async function getAdvanceDisbursementLedger() {
  const response = await apiClient.get("/advances/disbursement-ledger");
  return extractData(response);
}
